import React, {Component} from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { findPhoneNumbersInText } from 'libphonenumber-js'
import axios from "axios"
import { validateEmail, getCookie, getParameterByName } from "./helpers";
import config from './config';

import logo from './assets/img/logo_edward.png';
import './assets/css/app.css';

class App extends Component {

    constructor (props) {
        super(props);

        this.state = {
            email: "",
            password: "",
            phoneNumber: "",
            platform: "android",
            phoneNumberInfo: {},
            terms: false,
            ref: null,
            lang: window.i18next.language.substring(0, 2).toLowerCase(),
            error: {
                email: false,
                password: false,
                phoneNumber: false,
                platform: false,
                terms: false
            }
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSendData = this.handleSendData.bind(this);
    }

    componentDidMount() {

        // if (getParameterByName('lang')) {
        //     localStorage.setItem('i18nextLng', getParameterByName('lang'));
        //     window.i18next.changeLanguage(getParameterByName('lang'));
        // }

        if (getParameterByName('ref')) {
            let text = getParameterByName('ref');
            if (text.match(/^[a-zA-Z0-9.;:\-_@]+$/g)) {
                this.setState({
                    ref: text
                })
            }
        } else if (getCookie('ref')){
            let text = getCookie('ref');
            if (text.match(/^[a-zA-Z0-9.;:\-_'@]+$/g)) {
                this.setState({
                    ref: text
                })
            }
        }
    }

    isValid(name, value) {
        let isValid = this.state.error[name];

        if (name === "email") {
            isValid = !value || !validateEmail(value) ? false : true;
        }
        if (name === "password") {
            isValid = !value ? false : true;
        }
        if (name === "phoneNumber") {
            const phoneNumber = findPhoneNumbersInText(value, this.state.lang.toUpperCase());
            isValid = phoneNumber.length > 0;
        }
        if (name === "terms") {
            isValid = !value ? false : true
        }
        if (name === "platform") {
            isValid = !value ? false : true
        }

        return isValid
    }

    handleInputChange(event) {
        const target = event.target;
        let value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        if (name === "phoneNumber") {
            const phones = findPhoneNumbersInText(value, this.state.lang.toUpperCase());
            this.setState({
                phoneNumberInfo:  phones && phones[0] ? phones[0].number : {}
            })
        }

        this.setState(prevState => ({
            [name]: value,
            error: {
                ...prevState.error,
                [name]: !this.isValid(name, value)
            }
        }));
    }

    handleSendData (event) {

        let messageRegistration = {
            dataType: "register",
            actionType: "create",
            data: {
                email: this.state.email,
                password: this.state.password,
                phoneNumber: this.state.phoneNumberInfo && this.state.phoneNumberInfo.number ? this.state.phoneNumberInfo.number : "",
                lang: this.state.lang,
                platform: this.state.platform,
                source: "lp"
            }
        };
        if (this.state.ref) {
            messageRegistration.data.ref = this.state.ref;
        }

        let errors = false;
        ["email", "password", "phoneNumber", "terms", "platform"].forEach( key => {
            this.setState(prevState => ({
                error: {
                    ...prevState.error,
                    [key]: !this.isValid(key, this.state[key])
                }
            }));
        });

        if (!messageRegistration.data.email || !validateEmail(messageRegistration.data.email)) {
            this.setState(prevState => ({
                errorMessage: this.props.t('form.email.error')
            }));
            return
        }

        if (!messageRegistration.data.password) {
            this.setState(prevState => ({
                errorMessage: this.props.t('form.password.error')
            }));
            return
        }

        if (!messageRegistration.data.phoneNumber) {
            this.setState(prevState => ({
                errorMessage: this.props.t('form.phoneNumber.error')
            }));
            return
        }

        if (!this.state.terms) {
            this.setState(prevState => ({
                errorMessage: this.props.t('form.terms.noCheck'),
            }));
            return
        }

        Object.keys(this.state.error).some( key => {
            if (this.state.error[key]) {
                console.error(`Error on ${key} field`);
                errors = true;
                return true
            }
        });

        if (!errors) {

            this.setState({
                errorMessage: null
            });

            axios.post(config.api.register_user_url, messageRegistration)
                .then( responseReg => {
                    if (responseReg.data.status === "success" && responseReg.data.id) {
                        const data = `username=${messageRegistration.data.email}&password=${encodeURIComponent(messageRegistration.data.password)}`;
                        axios.post(config.api.log_user_url, data, {
                            timeout: 3000,
                            headers: { 'Content-type': 'application/x-www-form-urlencoded' }
                        })
                            .then( response => {
                                if (response.status === 200) {
                                    sessionStorage.setItem("onb", JSON.stringify({sessionId: responseReg.data.id, email: messageRegistration.data.email}));
                                    window.location = config.api.demo_url;
                                } else {
                                    window.location = config.api.login_page_url;
                                }
                            }).catch( error => {
                                console.error("Error on login to dashboard", error);
                                this.setState({
                                    errorMessage: this.props.t("form.backend.error.login")
                                });
                            });
                    } else {
                        let msg = responseReg.data.errorMessage || responseReg.data.error || responseReg.data.message;
                        console.error("Error on login to dashboard:", msg);
                        this.setState({
                            errorMessage: msg
                        });
                    }
                })
                .catch( error => {
                    console.error("Error on creating account", error);
                    this.setState({
                        errorMessage: this.props.t("form.backend.error.createAccount")
                    });
                });
        }
    }

    render() {

        const { t } = this.props;

        return (
            <Router basename={config.basename}>
                <Switch>
                    <Route path="/">
                        <div className="app">
                            <a href="https://edward.ai"><img src={logo} className="logo" alt="Edward.ai"/></a>
                            <div className="space-block">
                                <h2 className="head-title">{t('page.headTitle')}</h2>
                                <p className="sub-title" dangerouslySetInnerHTML={{__html: t('page.subTitle')}} />
                                <div className="form-container">
                                    <div className="form-box">
                                        <div className="form-group">
                                            <input type="email" name="email" value={this.state.email} /*required*/ className={`form-control ${this.state.error.email && "is-invalid"}`} placeholder={t('form.email.placeholder')} onChange={this.handleInputChange} />
                                        </div>
                                        <div className="form-group">
                                            <input type="password" name="password" value={this.state.password} /*required*/ className={`form-control ${this.state.error.password && "is-invalid"}`} placeholder={t('form.password.placeholder')} onChange={this.handleInputChange}  />
                                        </div>
                                        <div className="form-group">
                                            <div className="input-group mb-2">
                                                <div className="input-group-prepend">
                                                    <div className="input-group-text f16"><span className={"flag " + (this.state.phoneNumberInfo && this.state.phoneNumberInfo.country ?  this.state.phoneNumberInfo.country.toLowerCase() : this.state.lang)} />{this.state.phoneNumberInfo && this.state.phoneNumberInfo.countryCallingCode ? <span style={{ paddingLeft: "5px" }}> +{this.state.phoneNumberInfo.countryCallingCode}</span> : ""}</div>
                                                </div>
                                                <input type="tel" name="phoneNumber" className={`form-control ${this.state.error.phoneNumber && "is-invalid"}`} onChange={this.handleInputChange} placeholder={t('form.phoneNumber.placeholder')} value={this.state.phoneNumber} />
                                            </div>
                                            <small className="form-text text-muted">{this.state.phoneNumberInfo && this.state.phoneNumberInfo.number ? `${t('form.phoneNumber.fullNumber')}: ${this.state.phoneNumberInfo.number} | ${t('form.phoneNumber.countryCode')}: ${this.state.phoneNumberInfo.country}` : ""}</small>
                                        </div>
                                        <div className="form-group">
                                            <div className="custom-control custom-radio">
                                                <input type="radio" className="custom-control-input" id="platformAndroid" name="platform" value="android" checked={this.state.platform === "android"} onChange={this.handleInputChange} />
                                                <label className="custom-control-label" htmlFor="platformAndroid">Android</label>
                                            </div>
                                            <div className="custom-control custom-radio">
                                                <input type="radio" className="custom-control-input" id="platformIos" name="platform" value="ios" checked={this.state.platform === "ios"} onChange={this.handleInputChange} />
                                                <label className="custom-control-label" htmlFor="platformIos">iOS</label>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="custom-control custom-checkbox">
                                                <input type="checkbox" required name="terms" className={`custom-control-input ${this.state.error.terms && "is-invalid"}`} id="terms-checkbox" value={this.state.terms} onChange={this.handleInputChange} />
                                                <label className="custom-control-label" htmlFor="terms-checkbox" dangerouslySetInnerHTML={{__html: t('form.terms.text') }} />
                                            </div>
                                        </div>
                                        <div className="form-group center mb-0 pt-3">
                                            <button type="submit" onClick={this.handleSendData} className={`big-btn btn-next ${this.state.terms ? "" : "disabled"}`}>{t('form.signUp')}</button>
                                        </div>
                                    </div>
                                    {this.state.errorMessage && <div className="form-validation fail d-block">{this.state.errorMessage}</div>}
                                </div>
                            </div>
                        </div>
                    </Route>
                </Switch>
            </Router>
        );
    }
}

export default withTranslation()(App);
